<ng-container *transloco="let t">
<div class="home-tabs">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel" mat-stretch-tabs="false">
    @for (tab of tabs(); track tab.id) {
      <a
        mat-tab-link
        [active]="tab.id === activeId()"
        (click)="select(tab.id)"
        >{{ tab.labelKey ? t(tab.labelKey) : tab.label }}</a
      >
    }
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
</ng-container>
